import styled from 'styled-components';

export const AttachmentContainer = styled.div`
    margin-bottom: 24px;
`;

export const FileInput = styled.input`
    display: none;
`;

export const UploadButton = styled.button`
    background: #579DFF;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;

    &:hover {
        background: #398BFF;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const AttachmentList = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 16px;
    margin-top: 16px;
`;

export const AttachmentItem = styled.div`
    background: #22272B;
    border-radius: 3px;
    overflow: hidden;
`;

export const ImagePreview = styled.div`
    width: 100%;
    aspect-ratio: 16/9;
    background-image: ${props => `url(${props.url})`};
    background-size: cover;
    background-position: center;
    cursor: pointer;
`;

export const FilePreview = styled.div`
    padding: 16px;
    cursor: pointer;
    color: #B6C2CF;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const DeleteButton = styled.button`
    background: none;
    border: none;
    color: #FF5630;
    padding: 4px 8px;
    cursor: pointer;
    font-size: 12px;
    width: 100%;
    text-align: left;

    &:hover {
        background: rgba(255, 86, 48, 0.1);
    }
`;

export const AttachmentTitle = styled.div`
    padding: 8px;
    font-size: 12px;
    color: #B6C2CF;
    word-break: break-all;
`;